import { whmcs } from './whmcs';
import { aws } from './aws';
import { cpanelProxy } from './cpanelProxy';
import { rdStation } from './rdStation';
import { customerSupport } from './customerSupport';
import { external } from './external';
import { n8n } from './n8n';
import { multiAgents } from './multiAgents';

const api = {
  aws,
  whmcs,
  cpanelProxy,
  rdStation,
  customerSupport,
  external,
  n8n,
  multiAgents,
};

export default api;
